import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const vitalsSelector = (state: RootState) => state.amwell.activeConsumer.vitals;

export const vitalsDataSelector = createSelector(vitalsSelector, v => v.data);
export const vitalsDataErrorSelector = createSelector(vitalsSelector, v => v.errors.data);
export const vitalsDataLoadingSelector = createSelector(vitalsSelector, v => v.loading.data);

export const vitalsActionLoadingSelector = createSelector(vitalsSelector, v => v.loading.action);
export const vitalsActionErrorSelector = createSelector(vitalsSelector, v => v.errors.action);
